import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/Button';
export function CTASection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 text-center bg-[#F2F4F0]" data-id="element-18">
      <div className="max-w-3xl mx-auto space-y-8" data-id="element-19">
        <h2 className="text-4xl md:text-5xl font-serif font-semibold text-text" data-id="element-20">
          Need something custom?
        </h2>

        <p className="text-xl text-muted font-sans" data-id="element-21">
          Got an app idea or need a solution we haven't built yet? Let's talk.
        </p>

        <div className="pt-4" data-id="element-22">
          <Link to="/contact" data-id="element-23">
            <Button size="lg" data-id="element-24">Get in Touch</Button>
          </Link>
        </div>
      </div>
    </section>;
}